// Recently viewed products: remembers product pages a shopper opens (localStorage)
// and renders them in <recently-viewed> with the same card as the product page rows
// (fetched from /products/<handle>?view=card), including quick view and add to cart.
const STORAGE_KEY = 'fwp-recently-viewed';
const MAX_ITEMS = 12;

function readHandles() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.filter((h) => typeof h === 'string') : [];
  } catch {
    return [];
  }
}

function saveHandle(handle) {
  if (!handle) return;
  const handles = [handle, ...readHandles().filter((h) => h !== handle)].slice(0, MAX_ITEMS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  } catch {}
}

function loadScript(src, isModule) {
  if (!src || document.querySelector(`script[src="${src}"]`)) return;
  const script = document.createElement('script');
  if (isModule) script.type = 'module';
  script.src = src;
  document.head.append(script);
}

class RecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.current;
    const handles = readHandles().filter((h) => h !== current).slice(0, 6);
    saveHandle(current);
    if (!handles.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const fragments = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=card`);
          if (!response.ok) return null;
          const html = await response.text();
          return html.includes('<li') ? html : null;
        } catch {
          return null;
        }
      })
    );
    const cards = fragments.filter(Boolean);
    if (!cards.length) return;

    const list = this.querySelector('[data-recently-viewed-list]');
    const template = document.createElement('template');
    template.innerHTML = cards.join('');
    // A product already on the page keeps its existing quick view; drop the duplicate dialog.
    template.content.querySelectorAll('dialog[id]').forEach((dialog) => {
      if (document.getElementById(dialog.id)) (dialog.closest('s-dialog') || dialog).remove();
    });
    list.replaceChildren(template.content);

    loadScript(this.dataset.formScript, true);
    loadScript(this.dataset.quickViewScript, false);
    this.hidden = false;
  }
}

if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
